import { Modal } from "react-bootstrap";

import { useAuth } from "../../hooks/useAuth";
import { PrintIcon } from "../Icons";

export default function PrintIssueItemModal({
  showPrintModal,
  setShowPrintModal,
  Trans_ID,
  warehouse,
  waybill,
}) {
  const { backendUrl } = useAuth();

  // G. A. do not close the modal when printing, user may want to print both receipt and waybill

  return (
    <Modal
      show={showPrintModal}
      onHide={() => setShowPrintModal(false)}
      centered={true}
      animation={false}
      enforceFocus={false}
      size="sm"
      close
    >
      <Modal.Header closeButton>
        <PrintIcon width={24} height={24} /> &nbsp;{" "}
        <Modal.Title className="h5">Print</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="">
          <div className="d-flex flex-column gap-3">
            <a
              className="btn btn-primary w-100 p-3 text-white"
              href={
                warehouse
                  ? `${warehouse}/${Trans_ID}`
                  : `${backendUrl}/api/invoice/pdf/issue-invoice/${Trans_ID}`
              }
              target="_blank"
              // onClick={() => setShowPrintModal(false)}
            >
              Print Receipt
            </a>

            {waybill && (
              <>
                <a
                  className="btn btn-primary w-100 p-3 text-white"
                  href={
                    waybill
                      ? `${waybill}/${Trans_ID}?waybill=${true}`
                      : `${backendUrl}/api/invoice/pdf/issue-invoice/${Trans_ID}`
                  }
                  target="_blank"
                  //  onClick={() => setShowPrintModal(false)}
                >
                  Print Waybill
                </a>
              </>
            )}
          </div>

          <hr />
          <button
            className="btn border w-100 p-3"
            onClick={() => setShowPrintModal(false)}
          >
            Close
          </button>
        </div>
      </Modal.Body>
    </Modal>
  );
}
